import { isEmpty, path } from 'ramda'

export const getNestedField = (name: string, object: object) => {
  const field = path<any>(name.split('.'), object)
  return isEmpty(field) ? null : field
}
